import { InputProps } from '@shared/ui/kit/input/model/types';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { CrossIcon } from '@shared/assets/icons';
import { Input } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import React from 'react';

interface InputClearableProps extends InputProps {
  clearHandler: () => void;
  className?: string;
}

const InputClearable: React.FC<InputClearableProps> = (props) => {
  const { clearHandler, className, ...inputProps } = props;
  const containerClassName = [stylex.props(styles.container).className, className].join(' ');

  return (
    <div className={containerClassName}>
      <Input {...inputProps} />

      {inputProps.value && (
        <UnstyledButton onClick={clearHandler} {...stylex.props(styles.crossIcon)}>
          <CrossIcon />
        </UnstyledButton>
      )}
    </div>
  );
};

export default InputClearable;
